import Vue from 'vue'
import Router from 'vue-router'

import sgcontent from '@/components/sgcontent'
import daiban from '@/components/daiban'
import video from '@/components/video'
import audiolist from '@/components/audiolist'
import banner from '@/components/banner'
import livebo from '@/components/livebo'
import assest from '@/components/assest'
import zhlan from '@/components/zhlan'
import newslist from '@/components/newslist'
import audiotopic from '@/components/audiotopic'
import lmset from '@/components/lmset'
import wjnoset from '@/components/wjnoset'
import sysUserlist from '@/components/sysUserlist'
import sysRolerole from '@/components/sysRolerole'
import sysmenu from '@/components/sysmenu'
import cwj from '@/components/cwj'
import goodslist from '@/components/goodslist'
import jfcity from '@/components/jfcity'
import orderlist from '@/components/orderlist'
import tp from '@/components/tp'
import appuser from '@/components/appuser'
import studentlist from '@/components/studentlist'
import classCir from '@/components/classCir'
import stupage from '@/components/stupage'
import userquestion from '@/components/userquestion'
import application from '@/components/application'
import pklist from '@/components/pklist'
import exam from '@/components/exam'

import canteenUselist from '@/components/canteenUselist'
import canteenRecord from '@/components/canteenRecord'
import canteenAmountRecord from '@/components/canteenAmountRecord'
import departlist from '@/components/departlist'
import lcd from '@/components/lcd'
import indepart from '@/components/indepart'
import appcenter from '@/components/appcenter'
import appcenterlist from '@/components/appcenterlist'
import bmhq from '@/components/bmhq'
import questions from '@/components/questions'
import onlearn from '@/components/onlearn'
import wjno from '@/components/wjno'

import login from '@/views/login'
import error from '@/views/error'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
      path: '/login',
      name: 'login',
      component: login,
    },
    {
      path: '',
      name: 'login',
      component: login,
    },
    {
      path: '/',
      name: 'sgcontent',
      component: sgcontent,
      redirect: "/daiban",
      children: [{
          path: 'db',
          name: 'daiban',
          component: daiban
        }, {
          path: 'video',
          name: 'video',
          component: video,
        }, {
          path: 'banner',
          name: 'banner',
          component: banner
        }, {
          path: 'onlearn',
          name: 'onlearn',
          component: onlearn,
        }, {
          path: 'zhlan',
          name: 'zhlan',
          component: zhlan
        }, {
          path: 'newslist',
          name: 'newslist',
          component: newslist
        }, {
          path: 'lmset',
          name: 'lmset',
          component: lmset
        }, {
          path: 'questions',
          name: 'questions',
          component: questions,
        }, {
          path: 'sysUserlist',
          name: 'sysUserlist',
          component: sysUserlist
        },
        {
          path: 'sysRolerole',
          name: 'sysRolerole',
          component: sysRolerole
        }, {
          path: 'sysmenu',
          name: 'sysmenu',
          component: sysmenu
        }, {
          path: 'canteenUselist',
          name: 'canteenUselist',
          component: canteenUselist,
        }, {
          path: 'departlist',
          name: 'departlist',
          component: departlist
        }, {
          path: 'studentlist',
          name: 'studentlist',
          component: studentlist,
        }, {
          path: 'indepart',
          name: 'indepart',
          component: indepart,
        }, {
          path: 'bmhq',
          name: 'bmhq',
          component: bmhq,
        }, {
          path: 'wjno',
          name: 'wjno',
          component: wjno,
        }, {
          path: 'wjnoset',
          name: 'wjnoset',
          component: wjnoset,
        },
      ]
    },
    {
      path: '*',
      name: 'error',
      component: error,
    }
  ]
})